import { getMappedEvents } from '../utils/getMappedEvents';

const EVENTS = [
  'recordingFeedbackBonusCtaClick',
  'recordingFeedbackBonusModalShown',
  'recordingFeedbackBonusSubmitted',
] as const;

export const recordingFeedbackBonusEvents = getMappedEvents([...EVENTS], {
  shouldSendSubscriptionData: true,
});
